import React, { useContext, useEffect } from "react";
import {
  Document,
  Page,
  StyleSheet,
  View,
  Text,
  Link,
  Image,
  Font,
  Svg,
  Path,
  Rect,
  G,
  ClipPath,
  Defs,
} from "@react-pdf/renderer";

import PoppinsLight from "../../../../assets/Poppins/Poppins-Light.ttf";
import PoppinsLightItalic from "../../../../assets/Poppins/Poppins-LightItalic.ttf";
import PoppinsRegular from "../../../../assets/Poppins/Poppins-Regular.ttf";
import PoppinsItalic from "../../../../assets/Poppins/Poppins-Italic.ttf";
import PoppinsMedium from "../../../../assets/Poppins/Poppins-Medium.ttf";
import PoppinsMediumItalic from "../../../../assets/Poppins/Poppins-MediumItalic.ttf";
import PoppinsSemiBold from "../../../../assets/Poppins/Poppins-SemiBold.ttf";
import PoppinsSemiBoldItalic from "../../../../assets/Poppins/Poppins-SemiBoldItalic.ttf";

import constants from "../../../../constants";
import moment from "moment";

const ProgressBar = ({ progress }) => {
  return (
    <View style={styleProgress.progressBarContainer}>
      <View style={styleProgress.progressBarBackground}>
        <View
          style={{ ...styleProgress.progressBarFill, width: `${progress}%` }}
        />
      </View>
    </View>
  );
};

const styleProgress = StyleSheet.create({
  progressBarContainer: {
    flexDirection: "row",
    alignItems: "center",
    // marginBottom: 10,
  },
  progressBarBackground: {
    width: "100%", // Width of the progress bar
    height: 4, // Height of the progress bar
    backgroundColor: "#FBEFED", // Background color for the progress bar
    borderRadius: 6,
    overflow: "hidden",
  },
  progressBarFill: {
    height: "100%", // Fill height to match the container
    backgroundColor: "#F97256", // Color of the progress fill
  },
});

Font.register({
  family: "Poppins",
  fonts: [
    {
      src: PoppinsLight,
      fontWeight: 300, // Light
    },
    {
      src: PoppinsLightItalic,
      fontWeight: 300, // Light Italic
      fontStyle: "italic",
    },
    {
      src: PoppinsRegular,
      fontWeight: 400, // Regular
    },
    {
      src: PoppinsItalic,
      fontWeight: 400, // Regular Italic
      fontStyle: "italic",
    },
    {
      src: PoppinsMedium,
      fontWeight: 500, // Medium
    },
    {
      src: PoppinsMediumItalic,
      fontWeight: 500, // Medium Italic
      fontStyle: "italic",
    },
    {
      src: PoppinsSemiBold,
      fontWeight: 600, // SemiBold
    },
    {
      src: PoppinsSemiBoldItalic,
      fontWeight: 600, // SemiBold Italic
      fontStyle: "italic",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15,
    // padding: 15,
    position: "relative",
    zIndex: 1,
    // paddingBottom: 20,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    borderRadius: 6,
    paddingBottom: 9,
    paddingTop: 9,
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 18,
    // borderRadius: 8,
    // paddingBottom: 12,
    // paddingTop: 12,
    // paddingLeft: 14,
    // paddingRight: 14,
    // marginBottom: 24,
    backgroundColor: "#F2F4F7",
  },
  personalDetail: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  nameRole: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // marginBottom: 5,
    // marginBottom: 3,
  },
  name: {
    fontFamily: "Poppins",
    // fontSize: 24,
    fontSize: 18,
    fontWeight: 600,
    // marginRight: 12,
    marginRight: 9,
    color: "#344054",
  },
  role: {
    fontFamily: "Poppins",
    fontStyle: "italic",
    // fontSize: 20,
    fontSize: 15,
    fontWeight: 300,
    color: "#344054",
  },
  socialDetails: {
    fontFamily: "Poppins",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
    // marginTop: 5,
    marginTop: 4,
  },
  socialLink: {
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 400,
    // marginRight: 10,
    marginRight: 8,
    color: "#344054",
    // borderRadius: 9
    borderRadius: 7,
  },
  socialLinkWithIcon: {
    display: "flex",
    flexDirection: "row",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 400,
    // marginRight: 10,
    marginRight: 8,
    color: "#344054",
  },
  socialLinkWithIconText: {
    // marginLeft: 4
    marginLeft: 3,
  },
  icon: {
    // width: 16,
    // height: 16,
    // marginRight: 5,
    width: 12,
    height: 12,
    marginRight: 4,
  },
  avatar: {
    // height: 92,
    // width: 92,
    // borderRadius: 50
    height: 69,
    width: 69,
    borderRadius: 38,
  },
  profileImage: {
    borderRadius: 38,
  },

  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 20,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    // padding: 10,
    // fontSize: 12,
    fontSize: 9,
    color: "#667085",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  footerText: {
    fontFamily: "Poppins",
    width: "50%",
  },

  // left
  pane: {
    display: "flex",
    flexDirection: "column",
    width: "53%",
    // padding: 10,
  },
  rightPane: {
    display: "flex",
    flexDirection: "column",
    width: "45%",
    // padding: 10,
    // padding: 8,
  },
  paneContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap:5,
    width: "100%",
  },
  contentHeader: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 600,
    // marginBottom: 4,
    marginBottom: 3,
    textAlign: "left",
    color: "#F96343",
  },
  contentBlock: {
    display: "flex",
    flexDirection: "column",
    // marginBottom: 16,
    marginBottom: 5,
  },
  contentText: {
    fontFamily: "Poppins",
    // fontSize: 14,
    fontSize: 10,
    fontStyle: "italic",
    fontWeight: 400,
    textAlign: "justify",
    color: "#344054",
  },
  educationBlock: {
    display: "flex",
    flexDirection: "column",
  },
  educationDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    // marginBottom: 12,
    // marginBottom: 9,
  },
  educationDetailsLine: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    textAlign: "center",
    // marginBottom: 6,
    marginBottom: 5,
  },
  achivements: {
    width: "100%",
    marginBottom: 5,
  },
  schoolName: {
    width: "75%",
    // fontSize: 16,
    fontSize: 12,
    fontWeight: 500,
    textAlign: "left",
    color: "#344054",
    fontFamily: "Poppins",
  },
  achivementstitle: {
    fontSize: 10,
    fontWeight: 400,
    textAlign: "left",
    color: "#344054",
    fontFamily: "Poppins",
    flex: 1, // Allow title to take full width
    flexWrap: "wrap", // Enable wrapping if necessary after full width is used
  },
  schoolDuration: {
    width: "20%",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 500,
    textAlign: "right",
    color: "#667085",
    fontFamily: "Poppins",
  },
  qualification: {
    width: "80%",
    // fontSize: 14,
    fontSize: 10,
    fontWeight: 400,
    textAlign: "left",
    color: "#667085",
    fontFamily: "Poppins",
  },
  cgpa: {
    width: "20%",
    // fontSize: 14,
    fontSize: 10,
    fontWeight: 500,
    // textAlign: "left",
    textAlign: "right",
    color: "#344054",
    fontFamily: "Poppins",
  },

  projectContainer: {
    display: "flex",
    flexDirection: "column",
    // marginBottom: 12,
    marginBottom: 9,
  },
  projectContainer2: {
    display: "flex",
    flexDirection: "column",
    // gap: 12, 
  },
  projectHeader: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 600,
    textAlign: "left",
    color: "#F96343",
    // marginBottom: 4,
    marginBottom: 3,
  },
  projectDetailsSec: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 9,
    // gap: 4,
  },
  projectTitleSec: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "nowrap",
  },
  projectTitleLeftSec: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // gap: 4,
    flex: 1,
    alignItems: 'flex-start'
  },
  projectTitle: {
    fontFamily: "Poppins",
    // fontSize: 16,
    fontSize: 12,
    fontWeight: 500,
    textAlign: "left",
    color: "#344054",
    flexShrink: 1, 
    flexWrap: "wrap",
    maxWidth: '70%'
  },
  projectDate: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 500,
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    color: "#667085",
  },
  projectLinks: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  projectLink: {
    display: "block",
    marginLeft: 6,
  },
  projectHashTagsSec: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    // marginBottom: 4,
    marginBottom: 3,
  },
  projectHashTag: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 500,
    fontStyle: "italic",
    textAlign: "left",
    color: "#F96343",
    // marginRight: 8,
    marginRight: 6,
  },
  projectDetails: {
    fontFamily: "Poppins",
    // fontSize: 14,
    fontSize: 10,
    fontWeight: 400,
    textAlign: "justify",
    color: "#344054",
    display: "block",
  },

  // right_pane_section

  bodyRightPane: {
    // width: "37%",
    display: "contents",
  },

  rightPaneTitle: {
    fontFamily: "Poppins",
    // fontSize: 16,
    fontSize: 12,
    display: "flex",
    fontWeight: 600,
    textAlign: "left",
  },

  wrapGevalBox: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },

  gevalBox: {
    // flex: 1,
    // borderRadius: 8,
    // marginTop: 12,
    // marginBottom: 6,
    borderRadius: 6,
    marginTop: 9,
    marginBottom: 5,
    border: "1px solid #D0D5DD",
    // width: '20%',
    flexGrow: 1,
    // maxWidth: 120,
    // marginRight: 10,
    maxWidth: 80,
    marginRight: 4,
  },

  gevalHeader: {
    // height: 40,
    // padding: 8,
    height: 30,
    padding: 6,
    display: "flex",
    backgroundColor: "#F2F4F7",
    // borderTopLeftRadius: 8,
    // borderTopRightRadius: 8,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },

  headerTitle: {
    fontFamily: "Poppins",
    display: "flex",
    flexDirection: "row",
    fontWeight: 600,
    color: "#667085",
    // fontSize: 14,
    fontSize: 10,
    textAlign: "left",
    alignItems: "center",
  },
  headerTitleName: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#667085",
    // fontSize: 14,
    fontSize: 10,
    // marginLeft: 8,
    marginLeft: 3,
  },

  gevalBody: {
    fontFamily: "Poppins",
    textAlign: "right",
    fontWeight: 600,
    // fontSize: 20,
    fontSize: 15,
    color: "#344054",
    fontStyle: "italic",
    // marginBottom: 7,
    // marginRight: 7,
    // marginTop: 13,
    marginBottom: 5,
    marginRight: 5,
    marginTop: 10,
    alignItems: "flex-end",
  },

  gevalBodyText: {
    width: "100%",
    textAlign: "right",
  },

  skillSection: {
    // marginTop: 28
    marginTop: 21,
  },

  skillSectionTitle: {
    fontFamily: "Poppins",
    display: "flex",
    fontWeight: 600,
    // fontSize: 16,
    fontSize: 12,
    color: "#344054",
    textAlign: "left",
    // marginBottom: 8,
    marginBottom: 6,
  },

  skillBox: {
    // padding: 8,
    padding: 6,
    display: "flex",
    // borderRadius: 6,
    // marginBottom: 20,
    borderRadius: 5,
    marginBottom: 15,
    flexDirection: "column",
    border: "1px solid #D0D5DD",
  },

  skillHeader: {
    display: "flex",
    flexDirection: "row",
    // paddingLeft: 8,
    // paddingRight: 8,
    // marginRight: 8,
    paddingLeft: 6,
    paddingRight: 6,
    marginRight: 6,
    justifyContent: "space-between",
    flexWrap: "nowrap",
  },

  skillNameSvg: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignItems: 'flex-start'
  },

  skillName: {
    fontFamily: "Poppins",
    // fontSize: 16,
    fontSize: 12,
    fontWeight: 600,
    color: "#101828",
    textAlign: "left",
    // marginRight: 8,
    marginRight: 6,
    flexShrink: 1, 
    flexWrap: "wrap",
    maxWidth: '75%'
  },

  skillPercentage: {
    fontFamily: "Poppins",
    // fontSize: 16,
    fontSize: 12,
    fontWeight: 600,
    color: "#F96343",
    textAlign: "left",
    fontStyle: "italic",
    whiteSpace: "nowrap",
  },

  skillTestDetails: {
    // paddingLeft: 8,
    // paddingRight: 8
    paddingLeft: 6,
    paddingRight: 6,
  },

  skillTests: {
    fontFamily: "Poppins",
    // fontSize: 14,
    fontSize: 10,
    fontWeight: 400,
    color: "#344054",
    textAlign: "left",
    // marginLeft: 10,
    // marginTop: 14,
    marginLeft: 8,
    marginTop: 6,
    marginVertical: 4,
  },

  skillRemark: {
    // marginTop: 10,
    marginTop: 8,
  },

  remark: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 600,
    color: "#344054",
    // paddingLeft: 8,
    // paddingRight: 8,
    paddingLeft: 6,
    paddingRight: 6,
    textAlign: "justify",
  },

  skillEndline: {
    // width: '100%',
    // display: 'block',
    // marginTop: 12,
    // marginBottom: 12,
    borderTopWidth: 1,
    borderTopColor: "#D0D5DD",
    marginTop: 9,
    marginBottom: 9,
    width: "100%",
  },
  overall: {
    display: "block",
    // borderRadius: 8,
    // paddingBottom: 12,
    // paddingTop: 12,
    // paddingLeft: 16,
    // paddingRight: 16,
    borderRadius: 6,
    paddingBottom: 9,
    paddingTop: 9,
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: "#FCEBE8",
    // marginBottom: 6,
    // padding: 16,
    // borderRadious: 8,
    marginBottom: 5,
    padding: 12,
    borderRadious: 6,
    position: "relative",
  },

  quote: {
    position: "absolute",
    right: 30,
    top: -10,
  },
  remark: {
    fontFamily: "Poppins",
    // fontSize: 16,
    fontSize: 12,
    fontWeight: 600,
    // marginBottom: 8,
    marginBottom: 6,
    color: "#344054",
  },
  bulletItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    // marginBottom: 4,
  },
  bulletPoint: {
    width: 3,
    height: 3,
    borderRadius: 3,
    backgroundColor: "#344054", // Bullet color
    marginRight: 5,
    marginTop: 10,
  },
  bulletItemOverall: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    // marginBottom: 4,
  },
  bulletPointOverall: {
    width: 3,
    height: 3,
    borderRadius: 3,
    backgroundColor: "#344054",
    marginRight: 5,
    marginTop: 5,
  },
  bulletItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    // marginBottom: 4,
  },
  bulletPoint: {
    width: 3,
    height: 3,
    borderRadius: 3,
    backgroundColor: "#344054",
    marginTop: 10,
  },
  remarkpoints: {
    fontFamily: "Poppins",
    // fontSize: 12,
    fontSize: 9,
    fontWeight: 400,
    color: "#344054",
  },

  exclude: {
    position: "absolute",
    zIndex: 0,
    top: '40%',
    left: '30%'
  }

});

const PDFDoc = ({
  PersonalDetail,
  resumeData,
  socialprofile,
  academic,
  sortedEntries,
  picturebase64,
}) => {
  const getYear = (datestring, format) => {
    let date = new Date(datestring);
    if (format == "year") return date.getFullYear(date);
    return date.toLocaleString("en-US", { month: "short" });
  };

  const getSkillPercentage = (skillData) => {
    const assignmentScore = getValue(
      skillData,
      constants.PROFILE_ATTRIBUTES.ASSIGNMENT_SCORE
    );
    const assessmentScore = getValue(
      skillData,
      constants.PROFILE_ATTRIBUTES.ASSESSMENT_SCORE
    );
    const totalTargetScore =
      (skillData[constants.PROFILE_ATTRIBUTES.ASSIGNMENT_SCORE]?.targetScore ||
        0) +
      (skillData[constants.PROFILE_ATTRIBUTES.ASSESSMENT_SCORE]?.targetScore ||
        0);
    let percentage =
      totalTargetScore > 0
        ? ((assignmentScore + assessmentScore) / totalTargetScore) * 100
        : 0;
    return percentage;
  };

  const formatPercentage = (percentage) => {
    if (percentage === 0) {
        return '0';
    }
    return percentage % 1 === 0 ? `${percentage}` : `${percentage.toFixed(2)}`;
}

  const getValue = (data, attribute, action) => {
    const overrideValue = data[attribute]?.overrideValue;
    let value;
    if (action === "totalCount") {
      value = data[attribute]?.totalCount;
      return value !== null && value !== undefined && value !== ""
        ? typeof value === "string"
          ? parseInt(value)
          : value
        : 0;
    } else if (action === "targetScore") {
      value = data[attribute]?.targetScore;
      return value !== null && value !== undefined && value !== ""
        ? typeof value === "string"
          ? parseInt(value)
          : value
        : 0;
    } else {
      value = data[attribute]?.value;
      return overrideValue !== null &&
        overrideValue !== undefined &&
        overrideValue !== ""
        ? /* typeof overrideValue === "string" ? overrideValue : */ overrideValue
        : value !== null && value !== undefined && value !== ""
        ? typeof value === "string"
          ? parseInt(value)
          : value
        : 0;
    }
  };

  const getlistFromParagraph = (para) => {
    if (!para) return [];
    return para
      .split("#")
      .map((sentence) => sentence.trim())
      .filter((sentence) => sentence !== "");
  };

  const addSpaceToParagraph = (expl, contrib, learn) => {
    return (
      (expl ? expl : "") +
      (contrib ? " " + contrib : "") +
      (learn ? " " + learn : "")
    );
  };

  const getTodayDate = () => {
    var date = new Date();
    var dat = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return `${dat}/${month}/${year}`;
  };

  const checkLink = (link) => {
    return link.startsWith("http") ? link : `https://${link}`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.exclude} fixed>
          <Svg width="256" height="256" viewBox="0 0 340 340" fill="none">
            <Path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M340 0H0V150C0 225.273 46.4404 292.754 116.757 319.648L170 340L223.243 319.648C293.56 292.754 340 225.273 340 150V0ZM240 120C240 158.652 208.66 190 170 190C131.34 190 100 158.652 100 120C100 81.3477 131.34 50 170 50H240V120ZM170 150C186.569 150 200 136.562 200 120C200 103.438 186.569 90 170 90C153.431 90 140 103.438 140 120C140 136.562 153.431 150 170 150ZM100 250C100 227.91 117.909 210 140 210H240C240 232.09 222.091 250 200 250H100Z"
              fill="#FFF8F6"
              fill-opacity="0.04"
            />
          </Svg>
        </View>
        <View style={styles.header}>
          <View style={styles.personalDetail}>
            <View style={styles.nameRole}>
              <Text style={styles.name}>
                {`${PersonalDetail?.firstName} ${
                  PersonalDetail?.lastName || ""
                }`}
              </Text>
              {PersonalDetail?.intro && (
                <Link
                  src={checkLink(PersonalDetail?.intro)}
                  style={styles.socialLink}
                >
                  {/* <Text style={styles.role}> */}
                  {/* <VideoSvg /> */}
                  <Svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Rect
                      width="20"
                      height="20"
                      rx="10"
                      ry="10"
                      fill="#F8E0DB"
                    />
                    <Path
                      d="M6.91797 5.91071C6.91797 5.3442 6.91797 5.06094 7.03609 4.9048C7.13899 4.76877 7.29627 4.6846 7.46653 4.67443C7.66197 4.66276 7.89766 4.81989 8.36902 5.13413L14.5031 9.22352C14.8926 9.48317 15.0873 9.613 15.1552 9.77664C15.2145 9.9197 15.2145 10.0805 15.1552 10.2236C15.0873 10.3872 14.8926 10.517 14.5031 10.7767L8.36902 14.8661C7.89766 15.1803 7.66197 15.3374 7.46653 15.3258C7.29627 15.3156 7.13899 15.2314 7.03609 15.0954C6.91797 14.9392 6.91797 14.656 6.91797 14.0895V5.91071Z"
                      fill="#F97256"
                    />
                  </Svg>

                  {/* </Text> */}
                </Link>
              )}
            </View>
            {resumeData?.roleTitle && resumeData?.roleTitle !== "" && (
              <Text style={styles.role}>{resumeData?.roleTitle}</Text>
            )}
            <View style={styles.socialDetails}>
              {PersonalDetail?.phone && (
                <Link
                  src={`https://wa.me/${PersonalDetail?.phone}`}
                  style={styles.socialLinkWithIcon}
                >
                  <Svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                    <Path
                      d="M14.665 11.2797V13.2797C14.6657 13.4654 14.6277 13.6492 14.5533 13.8193C14.479 13.9894 14.3699 14.1421 14.233 14.2676C14.0962 14.3932 13.9347 14.4887 13.7588 14.5482C13.5829 14.6077 13.3966 14.6298 13.2117 14.6131C11.1602 14.3902 9.18966 13.6892 7.45833 12.5664C5.84755 11.5428 4.48189 10.1772 3.45833 8.56641C2.33165 6.82721 1.63049 4.84707 1.41166 2.78641C1.395 2.60205 1.41691 2.41625 1.47599 2.24082C1.53508 2.0654 1.63004 1.9042 1.75484 1.76749C1.87964 1.63077 2.03153 1.52155 2.20086 1.44675C2.37018 1.37196 2.55322 1.33325 2.73833 1.33307H4.73833C5.06187 1.32989 5.37552 1.44446 5.62084 1.65543C5.86615 1.8664 6.02638 2.15937 6.07166 2.47974C6.15608 3.11978 6.31263 3.74822 6.53833 4.35307C6.62802 4.59169 6.64744 4.85102 6.59427 5.10033C6.5411 5.34964 6.41757 5.57848 6.23833 5.75974L5.39166 6.60641C6.3407 8.27544 7.72263 9.65737 9.39166 10.6064L10.2383 9.75974C10.4196 9.5805 10.6484 9.45697 10.8977 9.4038C11.1471 9.35063 11.4064 9.37004 11.645 9.45974C12.2498 9.68544 12.8783 9.84199 13.5183 9.92641C13.8422 9.97209 14.1379 10.1352 14.3493 10.3847C14.5608 10.6343 14.6731 10.9528 14.665 11.2797Z"
                      fill="#667085"
                    />
                  </Svg>{" "}
                  <Text style={styles.socialLinkWithIconText}>
                    {PersonalDetail?.phone}
                  </Text>
                </Link>
              )}
              {PersonalDetail?.email && (
                <Link
                  src={`mailto:${PersonalDetail?.email}`}
                  style={styles.socialLinkWithIcon}
                >
                  <Svg
                    width="13"
                    height="13"
                    viewBox="0 0 16 16"
                    fill="#667085"
                  >
                    <Path
                      d="M2.66536 2.66699H13.332C14.0654 2.66699 14.6654 3.26699 14.6654 4.00033V12.0003C14.6654 12.7337 14.0654 13.3337 13.332 13.3337H2.66536C1.93203 13.3337 1.33203 12.7337 1.33203 12.0003V4.00033C1.33203 3.26699 1.93203 2.66699 2.66536 2.66699Z"
                      fill="#667085"
                    />
                    <Path
                      d="M14.6654 4.00033L7.9987 8.66699L1.33203 4.00033"
                      fill="#667085"
                    />
                    <Path
                      d="M14.6654 4.00033C14.6654 3.26699 14.0654 2.66699 13.332 2.66699H2.66536C1.93203 2.66699 1.33203 3.26699 1.33203 4.00033M14.6654 4.00033V12.0003C14.6654 12.7337 14.0654 13.3337 13.332 13.3337H2.66536C1.93203 13.3337 1.33203 12.7337 1.33203 12.0003V4.00033M14.6654 4.00033L7.9987 8.66699L1.33203 4.00033"
                      stroke="#F2F4F7"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </Svg>{" "}
                  <Text style={styles.socialLinkWithIconText}>
                    {PersonalDetail?.email}
                  </Text>
                </Link>
              )}
              {socialprofile?.linkedIn && (
                <Link
                  src={checkLink(socialprofile["linkedIn"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 20 20" fill="none">
                    <Rect
                      x="1.25"
                      y="1.25"
                      width="17.5"
                      height="17.5"
                      rx="8.75"
                      ry="8.75"
                      fill="#667085"
                    />
                    <Path
                      d="M7.8866 6.05759C7.8866 6.64169 7.38032 7.11519 6.7558 7.11519C6.13128 7.11519 5.625 6.64169 5.625 6.05759C5.625 5.4735 6.13128 5 6.7558 5C7.38032 5 7.8866 5.4735 7.8866 6.05759Z"
                      fill="white"
                    />
                    <Path
                      d="M5.77964 7.89256H7.71263V13.75H5.77964V7.89256Z"
                      fill="white"
                    />
                    <Path
                      d="M10.8247 7.89256H8.89175V13.75H10.8247C10.8247 13.75 10.8247 11.906 10.8247 10.753C10.8247 10.061 11.061 9.36596 12.0039 9.36596C13.0694 9.36596 13.063 10.2716 13.058 10.9732C13.0515 11.8903 13.067 12.8262 13.067 13.75H15V10.6586C14.9836 8.68461 14.4693 7.77505 12.7771 7.77505C11.7721 7.77505 11.1492 8.23129 10.8247 8.64406V7.89256Z"
                      fill="white"
                    />
                  </Svg>
                </Link>
              )}
              {socialprofile?.git && (
                <Link
                  src={checkLink(socialprofile["git"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 20 20" fill="none">
                    <Path
                      d="M1.61585 10.8832C1.12805 10.3954 1.12805 9.60456 1.61585 9.11676L9.11676 1.61585C9.60456 1.12805 10.3954 1.12805 10.8832 1.61585L18.3842 9.11676C18.872 9.60456 18.872 10.3954 18.3841 10.8832L10.8832 18.3842C10.3954 18.872 9.60456 18.872 9.11676 18.3841L1.61585 10.8832Z"
                      fill="#667085"
                    />
                    <Path
                      d="M7.59162 3.16309L6.83203 3.92267L8.79385 5.88449C8.71449 6.05475 8.67018 6.24464 8.67018 6.44487C8.67018 7.01337 9.02737 7.49844 9.52956 7.68791V12.487C9.02737 12.6765 8.67018 13.1615 8.67018 13.73C8.67018 14.4635 9.26481 15.0582 9.99831 15.0582C10.7318 15.0582 11.3264 14.4635 11.3264 13.73C11.3264 13.2146 11.0328 12.7678 10.6038 12.5476V7.69442L12.4791 9.56975C12.4036 9.73656 12.3616 9.92174 12.3616 10.1167C12.3616 10.8503 12.9562 11.4449 13.6897 11.4449C14.4232 11.4449 15.0178 10.8503 15.0178 10.1167C15.0178 9.38324 14.4232 8.78862 13.6897 8.78862C13.5472 8.78862 13.4099 8.81108 13.2812 8.85264L11.2671 6.83858C11.3057 6.71417 11.3264 6.58195 11.3264 6.44487C11.3264 5.71137 10.7318 5.11675 9.99831 5.11675C9.86123 5.11675 9.72901 5.13751 9.6046 5.17607L7.59162 3.16309Z"
                      fill="white"
                    />
                  </Svg>
                </Link>
              )}
              {socialprofile?.github && (
                <Link
                  src={checkLink(socialprofile["github"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 20 20" fill="none">
                    <Path
                      d="M10 1.25C5.16562 1.25 1.25 5.16562 1.25 10C1.25 13.8719 3.75469 17.1422 7.23281 18.3016C7.67031 18.3781 7.83437 18.1156 7.83437 17.8859C7.83437 17.6781 7.82344 16.9891 7.82344 16.2563C5.625 16.6609 5.05625 15.7203 4.88125 15.2281C4.78281 14.9766 4.35625 14.2 3.98438 13.9922C3.67812 13.8281 3.24063 13.4234 3.97344 13.4125C4.6625 13.4016 5.15469 14.0469 5.31875 14.3094C6.10625 15.6328 7.36406 15.2609 7.86719 15.0312C7.94375 14.4625 8.17344 14.0797 8.425 13.8609C6.47813 13.6422 4.44375 12.8875 4.44375 9.54062C4.44375 8.58906 4.78281 7.80156 5.34062 7.18906C5.25313 6.97031 4.94687 6.07344 5.42812 4.87031C5.42812 4.87031 6.16094 4.64063 7.83437 5.76719C8.53438 5.57031 9.27813 5.47187 10.0219 5.47187C10.7656 5.47187 11.5094 5.57031 12.2094 5.76719C13.8828 4.62969 14.6156 4.87031 14.6156 4.87031C15.0969 6.07344 14.7906 6.97031 14.7031 7.18906C15.2609 7.80156 15.6 8.57812 15.6 9.54062C15.6 12.8984 13.5547 13.6422 11.6078 13.8609C11.925 14.1344 12.1984 14.6594 12.1984 15.4797C12.1984 16.65 12.1875 17.5906 12.1875 17.8859C12.1875 18.1156 12.3516 18.3891 12.7891 18.3016C14.5261 17.7152 16.0355 16.5988 17.1048 15.1096C18.1741 13.6204 18.7495 11.8333 18.75 10C18.75 5.16562 14.8344 1.25 10 1.25Z"
                      fill="#667085"
                    />
                  </Svg>
                </Link>
              )}
              {socialprofile?.leetCode && (
                <Link
                  src={checkLink(socialprofile["leetCode"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                    <G clip-path="url(#clip0_5673_10727)">
                      <Path
                        d="M10.7352 11.9534L8.93725 13.6914C8.62658 14.0027 8.19658 14.1327 7.72192 14.1327C7.24725 14.1327 6.81725 14.0027 6.50592 13.6914L3.61792 10.7827C3.30658 10.4714 3.14992 10.0161 3.14992 9.54074C3.14992 9.06541 3.30658 8.63607 3.61792 8.32474L6.49725 5.40474C6.80858 5.09341 7.24725 4.97474 7.72192 4.97474C8.19658 4.97474 8.62658 5.10474 8.93725 5.41607L10.7352 7.15341C11.0779 7.49674 11.6453 7.48474 12.0019 7.12807C12.3586 6.77074 12.3706 6.20341 12.0279 5.86074L10.2886 4.10341C9.83949 3.65944 9.2747 3.3506 8.65858 3.21207L10.3033 1.54341C10.6473 1.20074 10.6353 0.63274 10.2786 0.276073C9.92192 -0.0805932 9.35392 -0.0919266 9.01058 0.25074L2.27725 6.98474C1.62325 7.63941 1.28125 8.54274 1.28125 9.54141C1.28125 10.5401 1.62325 11.4714 2.27725 12.1247L5.17525 15.0321C5.82925 15.6847 6.73325 16.0001 7.73125 16.0001C8.72925 16.0001 9.63325 15.6587 10.2879 15.0041L12.0273 13.2461C12.3699 12.9034 12.3579 12.3361 12.0012 11.9794C11.6446 11.6227 11.0772 11.6107 10.7352 11.9534ZM13.8746 8.67341H7.11125C6.64325 8.67341 6.26458 9.07607 6.26458 9.57074C6.26458 10.0654 6.64325 10.4681 7.11125 10.4681H13.8746C14.3419 10.4681 14.7212 10.0654 14.7212 9.57074C14.7212 9.07607 14.3419 8.67341 13.8746 8.67341Z"
                        fill="#667085"
                      />
                    </G>
                    <Defs>
                      <ClipPath id="clip0_5673_10727">
                        <Rect width="16" height="16" fill="white" />
                      </ClipPath>
                    </Defs>
                  </Svg>
                </Link>
              )}
              {socialprofile?.codeChef && (
                <Link
                  src={checkLink(socialprofile["codeChef"])}
                  style={styles.socialLink}
                >
                  <Svg
                    width="13"
                    height="13"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <G clip-path="url(#clip0_5669_10714)">
                      <Path
                        d="M7.33993 -0.00042534C6.81526 0.0202413 6.32993 0.246241 5.8586 0.456241C5.45776 0.645887 5.04217 0.802626 4.61593 0.924908C4.1926 1.04224 3.74926 1.16091 3.4066 1.45024C3.2586 1.57024 3.16926 1.74291 3.05393 1.89157C2.84793 2.21557 2.75526 2.60291 2.74926 2.98357C2.77326 3.39024 2.89326 3.78357 2.99993 4.17424C3.24526 5.01557 3.53793 5.84291 3.79793 6.68024C4.04193 7.45424 4.2666 8.24291 4.6606 8.95757C4.79193 9.22024 4.89393 9.49624 5.01726 9.76157C5.03526 9.80624 5.05193 9.86691 5.11193 9.86091C5.2026 9.85291 5.27393 9.78424 5.35726 9.75157C5.90926 9.47557 6.51726 9.32357 7.12726 9.25224C7.59926 9.20291 8.0806 9.20024 8.54793 9.28824C9.02793 9.39691 9.4926 9.57224 9.9426 9.77091C10.1826 9.88557 10.4219 10.0029 10.6679 10.1029C10.6999 10.1296 10.7579 10.1416 10.7746 10.0922C10.9206 9.87424 11.0873 9.66891 11.2193 9.44157C11.5493 8.73424 11.5673 7.92224 11.9113 7.22091C12.1499 6.74024 12.5059 6.32957 12.7553 5.85557C12.8719 5.67824 13.0426 5.54424 13.1473 5.35757C13.4386 4.91157 13.6673 4.42557 13.8473 3.92424C13.9153 3.72891 13.9619 3.51624 13.9073 3.31157C13.8673 3.11224 13.7726 2.93157 13.6953 2.74624C13.6551 2.59138 13.5927 2.44317 13.5099 2.30624C13.2386 1.85557 12.7966 1.54024 12.3479 1.28224C11.6513 0.888908 10.8839 0.636241 10.1139 0.428908C9.29705 0.212044 8.46199 0.0705626 7.61926 0.00624133C7.52606 0.000101163 7.43332 -0.00212302 7.33993 -0.00042534ZM6.74726 0.403575C6.57326 0.552241 6.50526 0.782908 6.43526 0.992241C6.32326 1.37091 6.25993 1.76757 6.29726 2.16291C6.33993 2.87091 6.4286 3.57624 6.51726 4.27957C6.63726 5.18091 6.77526 6.07957 6.9686 6.96891C6.98593 7.07891 7.01126 7.20024 7.00193 7.30891C6.92526 7.19224 6.8806 7.05357 6.82993 6.92224C6.66326 6.41224 6.54193 5.88957 6.42726 5.36624C6.22216 4.41906 6.09684 3.45636 6.0526 2.48824C6.03593 1.92624 6.04993 1.33757 6.29926 0.820908C6.37793 0.670241 6.47193 0.514241 6.61926 0.422908C6.66376 0.398807 6.71407 0.3875 6.7646 0.390241L6.74726 0.403575ZM4.34593 1.17957C4.43126 1.17957 4.4386 1.28557 4.45793 1.34757C4.63526 1.87957 4.73926 2.43291 4.9106 2.96624C5.0266 3.39891 5.06926 3.84824 5.11593 4.29357C5.1806 4.98624 5.18793 5.68357 5.27993 6.37357C5.29726 6.50624 5.3346 6.63557 5.35926 6.76691C5.36593 6.81157 5.31993 6.79957 5.30393 6.77624C5.20526 6.66891 5.18193 6.51557 5.13993 6.38157C5.03326 5.95157 4.9786 5.51157 4.91726 5.07357C4.80126 4.19624 4.72593 3.31357 4.5646 2.44357C4.45926 2.03557 4.32726 1.63357 4.25793 1.21824C4.26193 1.18424 4.31993 1.18624 4.34593 1.17957ZM3.06126 2.40424C3.21393 2.44157 3.3046 2.58291 3.4026 2.69357C3.66926 3.05024 3.7626 3.49624 3.86593 3.92224C4.0546 4.76557 4.16326 5.62424 4.34926 6.46891C4.4366 6.91291 4.5446 7.35291 4.68726 7.78291C4.6966 7.81691 4.7106 7.87157 4.7126 7.89624C4.55726 7.60957 4.4506 7.29891 4.33593 6.99424C3.93726 5.86224 3.78726 4.66357 3.46926 3.50891C3.3806 3.19024 3.26393 2.87557 3.07193 2.60357C3.0406 2.54491 3.0186 2.46757 3.04726 2.40557C3.05126 2.40291 3.05726 2.40357 3.06126 2.40424ZM11.4919 11.2016C11.4013 11.2062 11.2853 11.2749 11.3079 11.3796C11.3706 11.5249 11.5306 11.5849 11.6586 11.6569C11.9526 11.8009 12.2839 11.8502 12.5639 12.0209C12.6253 12.0609 12.6633 12.1522 12.6066 12.2122C12.4866 12.3896 12.2933 12.5056 12.1246 12.6349C11.8766 12.8122 11.6066 12.9749 11.4199 13.2209C11.3759 13.2922 11.3926 13.3989 11.4746 13.4342C11.5473 13.4869 11.6366 13.4462 11.6999 13.4002C12.0453 13.2042 12.3633 12.9642 12.6853 12.7322C12.8986 12.5729 13.1146 12.4142 13.3026 12.2256C13.3593 12.1356 13.2826 12.0429 13.2239 11.9782C13.0419 11.7882 12.8106 11.6536 12.5806 11.5316C12.2758 11.3716 11.9478 11.2603 11.6086 11.2016C11.5698 11.1988 11.5308 11.1988 11.4919 11.2016ZM3.97526 11.2196C3.62393 11.3089 3.3106 11.4996 2.9926 11.6682C2.70926 11.8302 2.42326 11.9989 2.18926 12.2289C2.11083 12.3187 2.0698 12.4351 2.0746 12.5542C2.11793 12.6262 2.20793 12.6476 2.27526 12.6916C2.84326 12.9862 3.43193 13.2396 4.0286 13.4702C4.1166 13.4982 4.20526 13.5456 4.29926 13.5416C4.4046 13.5282 4.50526 13.4056 4.44126 13.3042C4.34393 13.1422 4.16126 13.0636 4.00793 12.9669C3.64326 12.7649 3.2386 12.6256 2.91726 12.3549C2.8866 12.2942 2.97993 12.2696 3.01193 12.2349C3.37793 11.9716 3.83126 11.8396 4.15393 11.5169C4.21326 11.4569 4.26326 11.3442 4.18593 11.2782C4.1286 11.2296 4.0486 11.2202 3.97526 11.2196ZM9.38526 11.7482C9.0986 11.7662 8.8286 12.0356 8.86926 12.3322C8.8906 12.5049 8.9286 12.6822 9.02126 12.8316C9.10126 12.9516 9.24126 13.0222 9.38526 13.0229C9.56726 13.0436 9.7786 12.9836 9.86926 12.8109C9.9606 12.6529 10.0106 12.4682 10.0059 12.2862C9.9806 11.9796 9.6946 11.7229 9.38526 11.7482ZM6.39193 11.7549C6.0826 11.7736 5.85393 12.0916 5.8786 12.3902C5.88593 12.6862 6.0886 12.9916 6.3886 13.0529C6.62326 13.0929 6.86193 12.9262 6.92393 12.6996C7.00726 12.4662 7.01193 12.1922 6.8946 11.9696C6.78993 11.8029 6.57593 11.7516 6.39193 11.7549ZM6.4666 12.1902C6.62726 12.2329 6.6626 12.5036 6.4966 12.5622C6.4026 12.5849 6.33726 12.4822 6.3406 12.3996C6.33526 12.3149 6.37393 12.2082 6.4666 12.1902ZM9.4246 12.2856C9.48926 12.2856 9.57526 12.3329 9.55126 12.4102C9.5426 12.5242 9.40793 12.6322 9.29993 12.5609C9.21193 12.5142 9.18526 12.3636 9.2866 12.3156C9.32926 12.2939 9.37678 12.2836 9.4246 12.2856ZM7.07926 14.2702C6.7106 14.3042 6.38326 14.4936 6.05126 14.6429C5.8486 14.7469 5.60993 14.8509 5.38126 14.7676C5.12993 14.6876 4.90993 14.5342 4.67526 14.4209C4.62526 14.4122 4.6346 14.4722 4.64393 14.5022C4.69793 14.8556 4.72993 15.2369 4.9466 15.5356C5.17193 15.8269 5.54793 15.9476 5.90193 15.9802C6.43326 16.0282 6.9966 15.9016 7.41593 15.5609C7.62193 15.3862 7.7966 15.1402 7.80593 14.8616C7.80193 14.6456 7.64326 14.4642 7.4566 14.3722C7.34256 14.3043 7.21202 14.269 7.07926 14.2702ZM8.79926 14.2756C8.53526 14.3102 8.25593 14.4502 8.15126 14.7089C8.06526 14.9476 8.17393 15.2076 8.3326 15.3889C8.6166 15.7282 9.04593 15.9176 9.47793 15.9782C9.8626 16.0302 10.2686 15.9876 10.6206 15.8182C10.9126 15.6682 11.1319 15.3816 11.1873 15.0569C11.2299 14.8629 11.2413 14.6636 11.2699 14.4676C11.2259 14.4156 11.1713 14.4929 11.1246 14.5022C10.8999 14.5969 10.6933 14.7469 10.4513 14.7922C10.2093 14.8082 9.99326 14.6776 9.7746 14.5969C9.48793 14.4782 9.20726 14.3282 8.89793 14.2782C8.86535 14.2754 8.83195 14.2745 8.79926 14.2756ZM6.8786 10.8816C6.83193 10.8816 6.78326 10.8909 6.7346 10.9016C6.63111 10.927 6.52989 10.9609 6.43193 11.0029C6.33193 11.0436 6.23726 11.0876 6.1606 11.1229C6.11276 11.1448 6.06429 11.1652 6.01526 11.1842C5.97342 11.1908 5.93058 11.1828 5.89393 11.1616C5.8526 11.1369 5.81393 11.0942 5.79993 10.9916L5.61993 11.0169C5.6406 11.1622 5.71326 11.2636 5.79993 11.3169C5.8866 11.3696 5.9786 11.3769 6.05193 11.3616C6.1086 11.3496 6.1586 11.3229 6.23593 11.2876C6.31326 11.2522 6.40593 11.2089 6.5006 11.1702C6.59593 11.1316 6.6926 11.0969 6.77393 11.0782C6.82859 11.0625 6.88629 11.0604 6.94193 11.0722C7.03526 11.1122 7.0686 11.1589 7.08526 11.1916C7.10193 11.2249 7.10526 11.2362 7.10526 11.2362L7.2806 11.1962C7.2806 11.1962 7.28193 11.1802 7.24726 11.1109C7.19608 11.0173 7.11343 10.9448 7.01393 10.9062C6.97092 10.8883 6.92518 10.8798 6.8786 10.8816ZM8.70793 13.5062C8.69486 13.5066 8.68202 13.5097 8.67028 13.5155C8.65855 13.5212 8.64819 13.5294 8.63993 13.5396C8.63993 13.5396 8.5586 13.6382 8.44926 13.7362C8.33926 13.8349 8.19593 13.9229 8.1206 13.9249C8.04593 13.9269 7.91126 13.8462 7.80726 13.7516C7.70393 13.6582 7.62926 13.5622 7.62926 13.5622C7.62228 13.552 7.61327 13.5433 7.60279 13.5367C7.59231 13.5301 7.58059 13.5257 7.56834 13.5238C7.5561 13.5219 7.54359 13.5225 7.5316 13.5256C7.5196 13.5287 7.50837 13.5343 7.4986 13.5419C7.48884 13.5495 7.48073 13.5591 7.4748 13.5699C7.46886 13.5808 7.46522 13.5928 7.46409 13.6051C7.46297 13.6175 7.46438 13.6299 7.46825 13.6417C7.47213 13.6535 7.47837 13.6643 7.4866 13.6736C7.4866 13.6736 7.56926 13.7802 7.68593 13.8862C7.8026 13.9929 7.9506 14.1109 8.12593 14.1062C8.2986 14.1009 8.4486 13.9796 8.56993 13.8716C8.69126 13.7629 8.77993 13.6549 8.77993 13.6549C8.79109 13.6415 8.79815 13.6252 8.80026 13.6079C8.80238 13.5906 8.79947 13.573 8.79187 13.5574C8.78427 13.5417 8.77231 13.5285 8.75743 13.5194C8.74254 13.5104 8.72535 13.5058 8.70793 13.5062ZM7.33993 -0.00042534C6.81526 0.0202413 6.32993 0.246241 5.8586 0.456241C5.45776 0.645887 5.04217 0.802626 4.61593 0.924908C4.1926 1.04224 3.74926 1.16091 3.4066 1.45024C3.2586 1.57024 3.16926 1.74291 3.05393 1.89157C2.84793 2.21557 2.75526 2.60291 2.74926 2.98357C2.77326 3.39024 2.89326 3.78357 2.99993 4.17424C3.24526 5.01557 3.53793 5.84291 3.79793 6.68024C4.04193 7.45424 4.2666 8.24291 4.6606 8.95757C4.79193 9.22024 4.89393 9.49624 5.01726 9.76157C5.03526 9.80624 5.05193 9.86691 5.11193 9.86091C5.2026 9.85291 5.27393 9.78424 5.35726 9.75157C5.90926 9.47557 6.51726 9.32357 7.12726 9.25224C7.59926 9.20291 8.0806 9.20024 8.54793 9.28824C9.02793 9.39691 9.4926 9.57224 9.9426 9.77091C10.1826 9.88557 10.4219 10.0029 10.6679 10.1029C10.6999 10.1296 10.7579 10.1416 10.7746 10.0922C10.9206 9.87424 11.0873 9.66891 11.2193 9.44157C11.5493 8.73424 11.5673 7.92224 11.9113 7.22091C12.1499 6.74024 12.5059 6.32957 12.7553 5.85557C12.8719 5.67824 13.0426 5.54424 13.1473 5.35757C13.4386 4.91157 13.6673 4.42557 13.8473 3.92424C13.9153 3.72891 13.9619 3.51624 13.9073 3.31157C13.8673 3.11224 13.7726 2.93157 13.6953 2.74624C13.6551 2.59138 13.5927 2.44317 13.5099 2.30624C13.2386 1.85557 12.7966 1.54024 12.3479 1.28224C11.6513 0.888908 10.8839 0.636241 10.1139 0.428908C9.29705 0.212044 8.46199 0.0705626 7.61926 0.00624133C7.52606 0.000101163 7.43332 -0.00212302 7.33993 -0.00042534ZM6.74726 0.403575C6.57326 0.552241 6.50526 0.782908 6.43526 0.992241C6.32326 1.37091 6.25993 1.76757 6.29726 2.16291C6.33993 2.87091 6.4286 3.57624 6.51726 4.27957C6.63726 5.18091 6.77526 6.07957 6.9686 6.96891C6.98593 7.07891 7.01126 7.20024 7.00193 7.30891C6.92526 7.19224 6.8806 7.05357 6.82993 6.92224C6.66326 6.41224 6.54193 5.88957 6.42726 5.36624C6.22216 4.41906 6.09684 3.45636 6.0526 2.48824C6.03593 1.92624 6.04993 1.33757 6.29926 0.820908C6.37793 0.670241 6.47193 0.514241 6.61926 0.422908C6.66376 0.398807 6.71407 0.3875 6.7646 0.390241L6.74726 0.403575ZM4.34593 1.17957C4.43126 1.17957 4.4386 1.28557 4.45793 1.34757C4.63526 1.87957 4.73926 2.43291 4.9106 2.96624C5.0266 3.39891 5.06926 3.84824 5.11593 4.29357C5.1806 4.98624 5.18793 5.68357 5.27993 6.37357C5.29726 6.50624 5.3346 6.63557 5.35926 6.76691C5.36593 6.81157 5.31993 6.79957 5.30393 6.77624C5.20526 6.66891 5.18193 6.51557 5.13993 6.38157C5.03326 5.95157 4.9786 5.51157 4.91726 5.07357C4.80126 4.19624 4.72593 3.31357 4.5646 2.44357C4.45926 2.03557 4.32726 1.63357 4.25793 1.21824C4.26193 1.18424 4.31993 1.18624 4.34593 1.17957ZM3.06126 2.40424C3.21393 2.44157 3.3046 2.58291 3.4026 2.69357C3.66926 3.05024 3.7626 3.49624 3.86593 3.92224C4.0546 4.76557 4.16326 5.62424 4.34926 6.46891C4.4366 6.91291 4.5446 7.35291 4.68726 7.78291C4.6966 7.81691 4.7106 7.87157 4.7126 7.89624C4.55726 7.60957 4.4506 7.29891 4.33593 6.99424C3.93726 5.86091 3.78726 4.66424 3.46926 3.50891C3.3806 3.19024 3.26393 2.87557 3.07193 2.60357C3.0406 2.54491 3.0186 2.46757 3.04726 2.40557C3.05126 2.40291 3.05726 2.40357 3.06126 2.40424ZM11.4919 11.2016C11.4013 11.2062 11.2853 11.2749 11.3079 11.3796C11.3706 11.5249 11.5306 11.5849 11.6586 11.6569C11.9526 11.8009 12.2839 11.8502 12.5639 12.0209C12.6253 12.0609 12.6633 12.1522 12.6066 12.2122C12.4866 12.3896 12.2933 12.5056 12.1246 12.6349C11.8766 12.8122 11.6066 12.9749 11.4199 13.2209C11.3759 13.2922 11.3926 13.3989 11.4746 13.4342C11.5473 13.4869 11.6366 13.4462 11.6999 13.4002C12.0453 13.2042 12.3633 12.9642 12.6853 12.7322C12.8986 12.5729 13.1146 12.4142 13.3026 12.2256C13.3593 12.1356 13.2826 12.0429 13.2239 11.9782C13.0419 11.7882 12.8106 11.6536 12.5806 11.5316C12.2758 11.3716 11.9478 11.2603 11.6086 11.2016C11.5698 11.1988 11.5308 11.1988 11.4919 11.2016ZM3.9746 11.2209C3.62326 11.3096 3.3106 11.5002 2.9926 11.6682C2.70926 11.8302 2.4226 12.0002 2.1886 12.2302C2.11033 12.3199 2.06997 12.4353 2.0746 12.5542C2.11793 12.6262 2.20793 12.6476 2.27526 12.6916C2.84326 12.9862 3.43193 13.2396 4.0286 13.4702C4.1166 13.4982 4.2046 13.5462 4.2986 13.5429C4.40393 13.5296 4.50526 13.4056 4.44126 13.3042C4.34393 13.1422 4.16126 13.0636 4.00793 12.9669C3.64326 12.7649 3.2386 12.6256 2.91726 12.3549C2.8866 12.2942 2.97993 12.2696 3.01193 12.2349C3.37793 11.9716 3.83126 11.8396 4.15393 11.5169C4.21326 11.4569 4.2626 11.3456 4.18526 11.2796C4.12793 11.2302 4.04793 11.2209 3.9746 11.2209ZM9.38526 11.7482C9.0986 11.7662 8.8286 12.0356 8.86926 12.3322C8.8906 12.5056 8.92793 12.6836 9.0206 12.8329C9.1006 12.9522 9.2406 13.0229 9.3846 13.0242C9.5666 13.0442 9.7786 12.9836 9.86926 12.8109C9.96194 12.6518 10.0092 12.4703 10.0059 12.2862C9.9806 11.9796 9.6946 11.7229 9.38526 11.7482ZM6.39193 11.7549C6.0826 11.7736 5.85393 12.0916 5.8786 12.3902C5.88593 12.6862 6.08793 12.9922 6.38793 13.0542C6.6226 13.0936 6.86126 12.9276 6.92326 12.7009C7.0066 12.4676 7.01193 12.1922 6.8946 11.9696C6.78993 11.8029 6.57593 11.7516 6.39193 11.7549ZM6.46593 12.1916C6.6266 12.2336 6.6626 12.5042 6.4966 12.5622C6.4026 12.5849 6.33726 12.4822 6.3406 12.3996C6.33526 12.3149 6.37326 12.2089 6.46593 12.1916ZM9.4246 12.2856C9.48926 12.2856 9.57526 12.3329 9.55126 12.4102C9.5426 12.5249 9.40726 12.6329 9.29926 12.5622C9.21126 12.5149 9.18526 12.3636 9.2866 12.3156C9.32926 12.2939 9.37678 12.2836 9.4246 12.2856ZM7.07926 14.2702C6.7106 14.3049 6.3826 14.4949 6.0506 14.6442C5.84793 14.7476 5.60993 14.8509 5.38126 14.7676C5.12993 14.6876 4.90993 14.5342 4.67526 14.4209C4.62526 14.4122 4.6346 14.4722 4.64393 14.5022C4.69793 14.8556 4.72993 15.2369 4.9466 15.5356C5.17193 15.8269 5.54793 15.9476 5.90193 15.9802C6.43326 16.0282 6.9966 15.9016 7.41593 15.5609C7.62193 15.3862 7.7966 15.1402 7.80593 14.8616C7.80193 14.6456 7.64326 14.4642 7.4566 14.3722C7.34256 14.3043 7.21202 14.269 7.07926 14.2702ZM8.79926 14.2756C8.53526 14.3102 8.25593 14.4502 8.15126 14.7089C8.06526 14.9482 8.17326 15.2082 8.33193 15.3902C8.61593 15.7289 9.04593 15.9176 9.47793 15.9782C9.8626 16.0302 10.2686 15.9876 10.6206 15.8182C10.9126 15.6682 11.1319 15.3816 11.1873 15.0569C11.2299 14.8629 11.2413 14.6636 11.2699 14.4676C11.2259 14.4156 11.1713 14.4929 11.1246 14.5022C10.8999 14.5976 10.6926 14.7476 10.4506 14.7936C10.2086 14.8096 9.99326 14.6782 9.7746 14.5969C9.48793 14.4782 9.2066 14.3296 8.89726 14.2796C8.86468 14.2767 8.83195 14.2758 8.79926 14.2769V14.2756Z"
                        fill="#667085"
                      />
                    </G>
                    <Defs>
                      <clipPath id="clip0_5669_10714">
                        <Rect width="16" height="16" fill="white" />
                      </clipPath>
                    </Defs>
                  </Svg>
                </Link>
              )}
              {socialprofile?.hackerRank && (
                <Link
                  src={checkLink(socialprofile["hackerRank"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 15 16" fill="none">
                    <Path
                      d="M14.1718 4.00002C13.7189 3.22029 8.16018 0 7.25489 0C6.34988 0 0.788952 3.21222 0.338689 4.00002C-0.111643 4.78781 -0.114148 11.2125 0.338689 12.0004C0.791491 12.7878 6.35051 16 7.25489 16C8.15925 16 13.719 12.7838 14.1715 12C14.6239 11.2163 14.6242 4.77971 14.1718 4.00002ZM9.12892 12.9444C9.00513 12.9444 7.85044 11.8266 7.9414 11.7353C7.96857 11.7081 8.13705 11.6891 8.48986 11.6781C8.48986 10.8584 8.50829 9.53469 8.51921 8.98056C8.52053 8.91747 8.50547 8.8734 8.50547 8.79774H6.00765C6.00765 9.01962 5.99332 9.92898 6.05051 11.0753C6.05764 11.2171 6.00111 11.2615 5.8711 11.2608C5.5545 11.26 5.23767 11.2574 4.9208 11.2584C4.79269 11.2587 4.73735 11.2106 4.74142 11.0675C4.77015 10.0225 4.83394 8.44181 4.73676 4.42155V4.32245C4.43457 4.31153 4.22486 4.29247 4.19735 4.26499C4.10608 4.17372 5.27673 3.05594 5.40017 3.05594C5.52393 3.05594 6.68675 4.17404 6.59611 4.26499C6.56891 4.29216 6.34922 4.31153 6.07204 4.32245V4.42124C5.99642 5.22594 6.00863 6.90841 5.98988 7.71468H8.49796C8.49796 7.57245 8.51017 6.62904 8.4605 5.10093C8.45733 4.99494 8.49017 4.93933 8.59201 4.93842C8.93793 4.93592 9.28419 4.93435 9.63045 4.93651C9.73856 4.93717 9.77324 4.99028 9.77108 5.10465C9.65699 11.0824 9.75042 10.6653 9.75042 11.6777C10.0276 11.6887 10.2761 11.7078 10.3033 11.7353C10.3933 11.8262 9.25268 12.9444 9.12892 12.9444Z"
                      fill="#667085"
                    />
                  </Svg>
                </Link>
              )}
              {socialprofile?.hackerEarth && (
                <Link
                  src={checkLink(socialprofile["hackerEarth"])}
                  style={styles.socialLink}
                >
                  <Svg width="13" height="13" viewBox="0 0 14 17" fill="none">
                    <Path
                      d="M12.9468 0.168869H5.28832V4.50891H5.36286C5.63761 4.15952 6.00272 3.89197 6.41864 3.73524C6.83457 3.57851 7.28545 3.53858 7.72245 3.61977C9.03631 3.69807 10.3175 4.49818 10.4038 7.04654V12.0827C10.4028 12.1327 10.3822 12.1804 10.3464 12.2154C10.3106 12.2504 10.2624 12.27 10.2124 12.2698H8.80572C8.75558 12.27 8.70739 12.2505 8.67149 12.2155C8.63559 12.1805 8.61485 12.1328 8.61373 12.0827V7.19884C8.61373 6.01047 8.22601 5.12294 7.04997 5.12294C6.81018 5.11841 6.57207 5.16372 6.35071 5.25601C6.12935 5.3483 5.92956 5.48555 5.76401 5.65907C5.59845 5.83259 5.47074 6.0386 5.38894 6.26405C5.30715 6.4895 5.27307 6.72947 5.28885 6.96878V12.0827C5.28787 12.1327 5.26725 12.1804 5.23144 12.2154C5.19562 12.2504 5.14749 12.27 5.09741 12.2698H3.69077C3.64069 12.27 3.59255 12.2504 3.55674 12.2154C3.52092 12.1804 3.5003 12.1327 3.49932 12.0827V0.168869H1.06465C0.79498 0.157529 0.531829 0.25365 0.332957 0.436134C0.134085 0.618617 0.0157427 0.872552 0.00390625 1.1422V15.1389C0.0130701 15.4144 0.128743 15.6756 0.326583 15.8675C0.524423 16.0594 0.789004 16.1671 1.06465 16.168H12.9468C13.0776 16.1653 13.2065 16.1363 13.3259 16.0826C13.4452 16.029 13.5525 15.9518 13.6413 15.8557C13.7301 15.7597 13.7987 15.6466 13.8428 15.5235C13.8869 15.4003 13.9057 15.2695 13.8981 15.1389V1.1422C13.9048 1.0145 13.8849 0.886799 13.8397 0.767163C13.7946 0.647527 13.7251 0.538548 13.6357 0.447098C13.5463 0.355648 13.439 0.283711 13.3204 0.235824C13.2018 0.187938 13.0746 0.16514 12.9468 0.168869ZM11.2554 14.1237H2.64558V13.2716H11.2559L11.2554 14.1237Z"
                      fill="#667085"
                    />
                  </Svg>
                </Link>
              )}
            </View>
          </View>
          <View style={styles.avatar}>
            <Image
              style={styles.profileImage}
              src={picturebase64 || resumeData?.personalData?.picture}
            />
          </View>
        </View>
        <View style={styles.paneContainer}>
          <View style={styles.pane}>
            {/* career objective */}
            {PersonalDetail &&
              PersonalDetail?.careerObj !== "" &&
              PersonalDetail?.careerObj !== null &&
              PersonalDetail?.careerObj !== undefined && (
                <View style={styles.contentBlock}>
                  <Text style={styles.contentHeader}>CAREER OBJECTIVE</Text>
                  <Text style={styles.contentText}>
                    {PersonalDetail?.careerObj}
                  </Text>
                </View>
              )}

            {/* Education */}
            {sortedEntries?.some(([key, data]) => 
                        data &&
                        Object.keys(data).length > 0 &&
                        data.schoolName?.trim() !== ""
                    ) && (
              <View style={styles.contentBlock}>
                <Text style={styles.contentHeader}>EDUCATION</Text>
                <View style={styles.educationBlock}>
                  {sortedEntries.map(
                    ([key, data]) =>
                      data &&
                      Object.keys(data).length > 0 && data.schoolName?.trim() !="" && (
                        <View style={styles.educationDetailsContainer}>
                          <View style={styles.educationDetailsLine}>
                            <Text style={styles.schoolName}>
                              {data.schoolName}
                            </Text>
                            <Text style={styles.schoolDuration}>
                              {`${
                                data.startdate
                                  ? getYear(data.startdate, "year")
                                  : ""
                              }${
                                data.enddate
                                  ? ` - ${getYear(data.enddate, "year")}`
                                  : ""
                              }`}
                            </Text>
                          </View>

                          <View style={styles.educationDetailsLine}>
                            <Text style={styles.qualification}>
                              {data.branch}
                            </Text>
                            <Text
                              style={styles.cgpa}
                            >{`CGPA : ${data.cgpa}`}</Text>
                          </View>
                        </View>
                      )
                  )}
                </View>
              </View>
            )}

            {academic
              ?.filter((data) => data.id === 1)
              .map((data) => {
                if (data.details && data.details.length > 0) {
                  return (
                    <View key={data.id} style={styles.projectContainer}>
                      <Text style={styles.projectHeader}>PROJECTS</Text>
                      <View style={styles.projectContainer2}>
                        {" "}
                        {data.details.map((detail) => (
                          <View
                            style={styles.projectDetailsSec}
                            key={detail.id}
                          >
                            <View style={styles.projectTitleSec}>
                              <View style={styles.projectTitleLeftSec}>
                                <View>
                                  <Text style={styles.projectTitle}>
                                    {detail.title}
                                  </Text>
                                </View>
                                <View style={styles.projectLinks}>
                                  {detail.projectLink && (
                                    <Link
                                      src={checkLink(detail.projectLink)}
                                      style={styles.projectLink}
                                    >
                                      <Svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <Rect
                                          width="18"
                                          height="18"
                                          rx="9"
                                          ry="9"
                                          fill="#F8E0DB"
                                        />
                                        <Path
                                          d="M6.5 5.49476C6.5 5.00917 6.5 4.76638 6.60125 4.63255C6.68945 4.51595 6.82426 4.4438 6.9702 4.43509C7.13772 4.42509 7.33973 4.55976 7.74376 4.82912L13.0015 8.3343C13.3354 8.55686 13.5023 8.66815 13.5605 8.80841C13.6113 8.93103 13.6113 9.06885 13.5605 9.19148C13.5023 9.33174 13.3354 9.44302 13.0015 9.66558L7.74376 13.1708C7.33973 13.4401 7.13772 13.5748 6.9702 13.5648C6.82426 13.5561 6.68945 13.4839 6.60125 13.3673C6.5 13.2335 6.5 12.9907 6.5 12.5051V5.49476Z"
                                          fill="#F97256"
                                        />
                                      </Svg>
                                    </Link>
                                  )}
                                  {detail.githubLink && (
                                    <Link
                                      src={checkLink(detail.githubLink)}
                                      style={styles.projectLink}
                                    >
                                      <Svg
                                        fill="none"
                                        width="16"
                                        height="16"
                                        viewBox={"0 0 20 18"}
                                      >
                                        <Path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={"1.5"}
                                          d={
                                            "M14.1665 13.1667L18.3332 9L14.1665 4.83333M5.83317 4.83333L1.6665 9L5.83317 13.1667M11.6665 1.5L8.33317 16.5"
                                          }
                                          stroke={"#667085"}
                                          fill="none"
                                        />
                                      </Svg>
                                    </Link>
                                  )}
                                  {detail.hostLink && (
                                    <Link
                                      src={checkLink(detail.hostLink)}
                                      style={styles.projectLink}
                                    >
                                      <Svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <G clip-path="url(#clip0_6330_12720)">
                                          <Path
                                            d="M6.6668 8.66697C6.9531 9.04972 7.31837 9.36642 7.73783 9.5956C8.1573 9.82477 8.62114 9.96105 9.0979 9.99519C9.57466 10.0293 10.0532 9.96055 10.501 9.79349C10.9489 9.62643 11.3555 9.36502 11.6935 9.02697L13.6935 7.02697C14.3007 6.3983 14.6366 5.55629 14.629 4.6823C14.6215 3.80831 14.2709 2.97227 13.6529 2.35424C13.0348 1.73621 12.1988 1.38565 11.3248 1.37806C10.4508 1.37046 9.60881 1.70644 8.98013 2.31364L7.83347 3.45364M9.33347 7.33364C9.04716 6.95088 8.68189 6.63418 8.26243 6.40501C7.84297 6.17584 7.37913 6.03956 6.90237 6.00541C6.4256 5.97127 5.94708 6.04006 5.49924 6.20711C5.0514 6.37417 4.64472 6.63559 4.3068 6.97364L2.3068 8.97364C1.69961 9.60231 1.36363 10.4443 1.37122 11.3183C1.37881 12.1923 1.72938 13.0283 2.3474 13.6464C2.96543 14.2644 3.80147 14.615 4.67546 14.6226C5.54945 14.6301 6.39146 14.2942 7.02013 13.687L8.16013 12.547"
                                            stroke="#667085"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            fill="none"
                                          />
                                        </G>
                                        <Defs>
                                          <ClipPath id="clip0_6330_12720">
                                            <Rect
                                              width="16"
                                              height="16"
                                              fill="white"
                                            />
                                          </ClipPath>
                                        </Defs>
                                      </Svg>
                                    </Link>
                                  )}
                                </View>
                              </View>
                              {detail?.startddate && (
                                <View>
                                  <Text style={styles.projectDate}>
                                    {moment(detail.startddate).format(
                                      "MMM YYYY"
                                    )}
                                  </Text>
                                </View>
                              )}
                            </View>
                            {detail.technologies && (
                              <View style={styles.projectHashTagsSec}>
                                {detail.technologies.map((tech) => (
                                  <Text style={styles.projectHashTag}>
                                    {tech}
                                  </Text>
                                ))}
                              </View>
                            )}
                            <View>
                              <View style={styles.projectDetails}>
                                <Text>
                                  {addSpaceToParagraph(
                                    detail.explaination,
                                    detail.contribution,
                                    detail.learn
                                  )}
                                </Text>
                              </View>
                            </View>
                          </View>
                        ))}
                      </View>
                    </View>
                  );
                }
                return null; // Return null if details are empty
              })}

            {academic
              ?.filter((data) => data.id === 4)
              .map((data) => {
                if (data.details && data.details.length > 0) {
                  return (
                    <View style={styles.contentBlock}>
                      <Text style={styles.contentHeader}>INTERNSHIPS</Text>
                      {data.details.map((detail) => (
                        <View style={styles.educationBlock}>
                          <View style={styles.educationDetailsContainer}>
                            <View style={styles.educationDetailsLine}>
                              <Text style={styles.schoolName}>
                                {detail.title}
                              </Text>
                              <Text style={styles.schoolDuration}>{`${
                                data.startdate
                                  ? getYear(data.startdate, "month")
                                  : ""
                              } - ${
                                data.startdate
                                  ? getYear(data.startdate, "month")
                                  : ""
                              }`}</Text>
                            </View>
                            <View style={styles.educationDetailsLine}>
                              <Text style={styles.qualification}>
                                {detail.organisation}
                              </Text>
                              <Text style={styles.cgpa}>{detail.city}</Text>
                            </View>
                            <View>
                              <Text>{detail.description}</Text>
                            </View>
                          </View>
                        </View>
                      ))}
                    </View>
                  );
                }
                return null;
              })}

            {academic
              ?.filter((data) => data.id === 2)
              .map((data) => {
                if (data.details && data.details.length > 0) {
                  return (
                    <View style={styles.contentBlock}>
                      <Text style={styles.contentHeader}>CERTIFICATES</Text>
                      {data.details.map((detail) => (
                        <View style={styles.educationBlock}>
                          <View style={styles.educationDetailsContainer}>
                            <View style={styles.educationDetailsLine}>
                              <Text style={styles.schoolName}>
                                {detail.title}
                              </Text>
                              <Text style={styles.schoolDuration}>
                                {detail.year}
                              </Text>
                            </View>
                            <View style={styles.educationDetailsLine}>
                              <Text style={styles.qualification}>
                                {detail.organisation}
                              </Text>
                            </View>
                          </View>
                        </View>
                      ))}
                    </View>
                  );
                }
                return null;
              })}

            {academic
              ?.filter((data) => data.id === 3)
              .map((data) => {
                if (data.details && data.details.length > 0) {
                  return (
                    <View style={styles.contentBlock}>
                      <Text style={styles.contentHeader}>ACHIEVEMENTS</Text>
                      {data.details.map((detail) => (
                            <View style={styles.achivements}>
                              <View style={styles.bulletItemOverall}>
                                <View style={styles.bulletPointOverall}></View>
                                <Text style={styles.achivementstitle}>
                                  {detail.title}
                                </Text>
                              </View>
                            </View>
                      ))}
                    </View>
                  );
                }
                return null;
              })}
          </View>

          {/* right side */}
          <View style={styles.rightPane}>
            <View style={styles.bodyRightPane}>
              <View>
                {resumeData?.GCAT &&
                  Object.keys(
                    typeof resumeData?.GCAT == "string"
                      ? JSON.parse(resumeData?.GCAT)
                      : resumeData?.GCAT
                  ).length > 0 && (
                    <View>
                      <Text style={styles.rightPaneTitle}>
                        GRADIOUS EVALUATION
                      </Text>
                      <View style={styles.wrapGevalBox}>
                        {Object.entries(
                          typeof resumeData?.GCAT == "string"
                            ? JSON.parse(resumeData?.GCAT)
                            : resumeData?.GCAT
                        ).map(([skill, data]) => (
                          <View style={styles.gevalBox}>
                            <View style={styles.gevalHeader}>
                              <View style={styles.headerTitle}>
                                {skill ==
                                  constants.PROFILE_ATTRIBUTES
                                    .APTITUDE_SCORE && (
                                  <Svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <Rect
                                      width="24"
                                      height="24"
                                      rx="12"
                                      ry="12"
                                      fill="#F96343"
                                    />
                                    <G clip-path="url(#clip0_6570_33790)">
                                      <Path
                                        d="M11.9987 5.33301C13.6662 7.15858 14.6139 9.5277 14.6654 11.9997C14.6139 14.4717 13.6662 16.8408 11.9987 18.6663M11.9987 5.33301C10.3312 7.15858 9.38353 9.5277 9.33203 11.9997C9.38353 14.4717 10.3312 16.8408 11.9987 18.6663M11.9987 5.33301C8.3168 5.33301 5.33203 8.31778 5.33203 11.9997C5.33203 15.6816 8.3168 18.6663 11.9987 18.6663M11.9987 5.33301C15.6806 5.33301 18.6654 8.31778 18.6654 11.9997C18.6654 15.6816 15.6806 18.6663 11.9987 18.6663M5.66538 9.99967H18.332M5.66536 13.9997H18.332"
                                        stroke="white"
                                        stroke-width="1.4"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        fill="none"
                                      />
                                    </G>
                                    <Defs>
                                      <ClipPath id="clip0_6570_33790">
                                        <Rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                          transform="translate(4 4)"
                                        />
                                      </ClipPath>
                                    </Defs>
                                  </Svg>
                                )}
                                {skill ==
                                  constants.PROFILE_ATTRIBUTES
                                    .GRAMMAR_SCORE && (
                                  <Svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <Rect
                                      width="24"
                                      height="24"
                                      rx="12"
                                      ry="12"
                                      fill="#F97256"
                                    />
                                    <Path
                                      d="M8.66667 9.66667H12M8.66667 12H14M10.4558 16H14.8C15.9201 16 16.4802 16 16.908 15.782C17.2843 15.5903 17.5903 15.2843 17.782 14.908C18 14.4802 18 13.9201 18 12.8V9.2C18 8.07989 18 7.51984 17.782 7.09202C17.5903 6.71569 17.2843 6.40973 16.908 6.21799C16.4802 6 15.9201 6 14.8 6H9.2C8.0799 6 7.51984 6 7.09202 6.21799C6.71569 6.40973 6.40973 6.71569 6.21799 7.09202C6 7.51984 6 8.0799 6 9.2V17.557C6 17.9122 6 18.0898 6.07282 18.1811C6.13615 18.2604 6.23218 18.3066 6.33369 18.3065C6.45042 18.3063 6.58911 18.1954 6.8665 17.9735L8.45681 16.7012C8.78168 16.4413 8.94411 16.3114 9.12499 16.219C9.28547 16.137 9.45628 16.0771 9.63281 16.0408C9.83178 16 10.0398 16 10.4558 16Z"
                                      stroke="white"
                                      strokeWidth="1.4"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      fill="none"
                                    />
                                  </Svg>
                                )}
                                {skill ==
                                  constants.PROFILE_ATTRIBUTES.CODING_SCORE && (
                                  <Svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <Rect
                                      width="24"
                                      height="24"
                                      rx="12"
                                      ry="12"
                                      fill="#F97256"
                                    />
                                    <Path
                                      d="M15.332 15.3333L18.6654 12L15.332 8.66667M8.66536 8.66667L5.33203 12L8.66536 15.3333M13.332 6L10.6654 18"
                                      stroke="white"
                                      strokeWidth="1.4"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      fill="none"
                                    />
                                  </Svg>
                                )}
                                <Text style={styles.headerTitleName}>
                                  {skill ==
                                  constants.PROFILE_ATTRIBUTES.APTITUDE_SCORE
                                    ? "Aptitude"
                                    : skill ==
                                      constants.PROFILE_ATTRIBUTES.GRAMMAR_SCORE
                                    ? "Grammar"
                                    : skill ==
                                      constants.PROFILE_ATTRIBUTES.CODING_SCORE
                                    ? "Coding"
                                    : ""}
                                </Text>
                              </View>
                            </View>
                            <View style={styles.gevalBody}>
                              <Text style={styles.gevalBodyText}>{`${
                                (typeof data.overrideValue === "string"
                                  ? data.overrideValue.trim() == ""
                                    ? 0
                                    : data.overrideValue.trim()
                                  : data.overrideValue) ||
                                (typeof data.value === "string"
                                  ? data.value.trim() == ""
                                    ? 0
                                    : data.value.trim()
                                  : data.value) ||
                                0
                              }%`}</Text>
                            </View>
                            {/* <View>
                                  <Progressbar
                                    from={"resume"}
                                    percentage={
                                      data.overrideValue != null &&
                                      data.overrideValue != "" &&
                                      data.overrideValue != undefined
                                        ? data.overrideValue
                                        : data.value != null &&
                                          data.value != undefined &&
                                          data.value != ""
                                        ? data.value
                                        : 0
                                    }
                                  />
                                </View> */}
                            <View>
                              <ProgressBar
                                progress={
                                  (typeof data.overrideValue === "string"
                                    ? data.overrideValue.trim() == ""
                                      ? 0
                                      : data.overrideValue.trim()
                                    : data.overrideValue) ||
                                  (typeof data.value === "string"
                                    ? data.value.trim() == ""
                                      ? 0
                                      : data.value.trim()
                                    : data.value) ||
                                  0
                                }
                              />
                            </View>
                          </View>
                        ))}
                      </View>
                    </View>
                  )}
              </View>

              <View style={styles.skillSection}>
                {resumeData?.skills &&
                  Object.keys(resumeData?.skills).length > 0 && (
                    <View>
                      <Text style={styles.skillSectionTitle}>
                        SKILL LEARNED
                      </Text>
                      <View style={styles.skillBox}>
                        {Object.entries(resumeData?.skills).map(
                          ([skillid, skillData], index, arr) => {
                            let hasRelevantData =
                              skillData.attributes[
                                constants.PROFILE_ATTRIBUTES.ASSIGNMENT_SCORE
                              ] ||
                              skillData.attributes[
                                constants.PROFILE_ATTRIBUTES.ASSESSMENT_SCORE
                              ];

                            if (hasRelevantData) {
                              // const encodedVideolink = encodeURI(skillData.videoLink);
                              return (
                                <View>
                                  <View style={styles.skillHeader}>
                                    <View style={styles.skillNameSvg}>
                                      <Text style={styles.skillName}>
                                        {skillData.skillname}
                                      </Text>
                                      {skillData.videoLink && (
                                        <Link
                                          src={checkLink(skillData.videoLink)}
                                          style={styles.socialLink}
                                        >
                                          <Svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <Rect
                                              width="18"
                                              height="18"
                                              rx="9"
                                              ry="9"
                                              fill="#F8E0DB"
                                            />
                                            <Path
                                              d="M6.5 5.49476C6.5 5.00917 6.5 4.76638 6.60125 4.63255C6.68945 4.51595 6.82426 4.4438 6.9702 4.43509C7.13772 4.42509 7.33973 4.55976 7.74376 4.82912L13.0015 8.3343C13.3354 8.55686 13.5023 8.66815 13.5605 8.80841C13.6113 8.93103 13.6113 9.06885 13.5605 9.19148C13.5023 9.33174 13.3354 9.44302 13.0015 9.66558L7.74376 13.1708C7.33973 13.4401 7.13772 13.5748 6.9702 13.5648C6.82426 13.5561 6.68945 13.4839 6.60125 13.3673C6.5 13.2335 6.5 12.9907 6.5 12.5051V5.49476Z"
                                              fill="#F97256"
                                            />
                                          </Svg>
                                        </Link>
                                      )}
                                    </View>
                                    <Text
                                      style={styles.skillPercentage}
                                    >{`${formatPercentage(getSkillPercentage(
                                      skillData.attributes
                                    ))}%`}</Text>
                                  </View>
                                  <View style={styles.skillTests}>
                                    <View style={styles.bulletItem} wrap={false}>
                                      <View style={styles.bulletPoint}></View>
                                      <Text
                                        style={styles.skillTests}
                                      >{`Submitted ${
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSIGNMENT_COMPLETED
                                        ) +
                                        "/" +
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSIGNMENT_COMPLETED,
                                          "totalCount"
                                        )
                                      } assignments & Scored ${
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSIGNMENT_SCORE
                                        ) +
                                        "/" +
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSIGNMENT_SCORE,
                                          "targetScore"
                                        )
                                      }.`}</Text>
                                    </View>
                                    <View style={styles.bulletItem} wrap={false}>
                                      <View style={styles.bulletPoint}></View>
                                      <Text style={styles.skillTests}>{`Scored ${
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSESSMENT_SCORE
                                        ) +
                                        "/" +
                                        getValue(
                                          skillData.attributes,
                                          constants.PROFILE_ATTRIBUTES
                                            .ASSESSMENT_SCORE,
                                          "targetScore"
                                        )
                                      } in all assessments combined.`}</Text>
                                    </View>

                                    {skillData.attributes[
                                      constants.PROFILE_ATTRIBUTES
                                        .SKILL_FEEDBACK
                                    ] &&
                                      getlistFromParagraph(
                                        skillData.attributes[
                                          constants.PROFILE_ATTRIBUTES
                                            .SKILL_FEEDBACK
                                        ]
                                      ).map((data, index) => (
                                        <View style={styles.bulletItem} wrap={false}>
                                          <View
                                            style={styles.bulletPoint}
                                          ></View>
                                          <Text
                                            style={styles.skillTests}
                                            key={index}
                                          >
                                            {data.trim()}
                                          </Text>
                                        </View>
                                      ))}
                                  </View>
                                  {index !== arr.length - 1 && (
                                    <View style={styles.skillEndline}></View>
                                  )}
                                </View>
                              );
                            }

                            return null;
                          }
                        )}
                      </View>
                    </View>
                  )}
              </View>
            </View>

            {resumeData?.overallFeedback !== "" &&
              resumeData?.overallFeedback !== null &&
              resumeData?.overallFeedback !== undefined && (
                <View style={styles.overall}>
                  <View style={styles.quote}>
                    <Svg
                      width="26"
                      height="21"
                      viewBox="0 0 26 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <Path
                        d="M6.48 20.4C5.30667 20.4 4.34667 20.16 3.6 19.68C2.85333 19.2 2.24 18.5867 1.76 17.84C1.22667 16.9333 0.853334 16 0.64 15.04C0.48 14.0267 0.4 13.2 0.4 12.56C0.4 9.94666 1.06667 7.57333 2.4 5.44C3.73333 3.30667 5.81333 1.57333 8.64 0.239995L9.36 1.68C7.70667 2.37333 6.26667 3.46666 5.04 4.96C3.86667 6.45333 3.28 7.97333 3.28 9.52C3.28 10.16 3.36 10.72 3.52 11.2C4.37333 10.5067 5.36 10.16 6.48 10.16C7.86667 10.16 9.06667 10.6133 10.08 11.52C11.0933 12.4267 11.6 13.68 11.6 15.28C11.6 16.7733 11.0933 18 10.08 18.96C9.06667 19.92 7.86667 20.4 6.48 20.4ZM20.08 20.4C18.9067 20.4 17.9467 20.16 17.2 19.68C16.4533 19.2 15.84 18.5867 15.36 17.84C14.8267 16.9333 14.4533 16 14.24 15.04C14.08 14.0267 14 13.2 14 12.56C14 9.94666 14.6667 7.57333 16 5.44C17.3333 3.30667 19.4133 1.57333 22.24 0.239995L22.96 1.68C21.3067 2.37333 19.8667 3.46666 18.64 4.96C17.4667 6.45333 16.88 7.97333 16.88 9.52C16.88 10.16 16.96 10.72 17.12 11.2C17.9733 10.5067 18.96 10.16 20.08 10.16C21.4667 10.16 22.6667 10.6133 23.68 11.52C24.6933 12.4267 25.2 13.68 25.2 15.28C25.2 16.7733 24.6933 18 23.68 18.96C22.6667 19.92 21.4667 20.4 20.08 20.4Z"
                        fill="#F96343"
                      />
                    </Svg>
                  </View>
                  <Text style={styles.remark}>Remark</Text>
                  {getlistFromParagraph(resumeData?.overallFeedback).map(
                    (data, index) => (
                      <View style={styles.bulletItemOverall} wrap={false}>
                        <View style={styles.bulletPointOverall}></View>
                        <Text
                          style={styles.remarkpoints}
                          key={index}
                          className="overall_remark_points"
                        >
                          {data.trim()}
                        </Text>
                      </View>
                    )
                  )}
                </View>
              )}
          </View>
        </View>
        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            {`Copyright Gradious Technologies (P) Ltd - ${new Date().getFullYear()}`}
          </Text>
          <Text style={[styles.footerText, { textAlign: "right" }]}>
            Download Date : {getTodayDate()}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PDFDoc;
